// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// const PERMANENT_EXCLUDED_COLUMNS = ['id', 'name', 'mobile', 'groupid', 'subgroupid'];
// const DEFAULT_COLUMNS = ['group_id', 'subgroup_id', 'flag', 'user_id'];

// const ColumnMapping = () => {
//   const [tables, setTables] = useState([]);
//   const [selectedTable, setSelectedTable] = useState('');
//   const [columns, setColumns] = useState([]);
//   const [mappings, setMappings] = useState([]);
//   const [tempName, setTempName] = useState('');

//   const [userId, setUserId] = useState('');
//   const [wid, setWid] = useState('');


//   // varma change 

//   //   const [waId, setWaId] = useState(null);

//   //   useEffect(() => {
//   //     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//   //     if (!loggedUser) return;
  
//   //     // ROLE-BASED EMAIL
//   //     const emailToUse =
//   //       loggedUser.role === "admin"
//   //         ? loggedUser.email
//   //         : loggedUser.adminEmail;
  
//   //     console.log("API Email Used:", emailToUse);
//   //     if (!emailToUse) return;
  
//   //     axios
//   //       .get(
//   //         `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//   //           emailToUse
//   //         )}`
//   //       )
//   //       .then((response) => {
//   //         const userData = response.data;
//   //         console.log("this is userData1", userData);
  
//   //         if (userData.wa_id) {
//   //           setWaId(userData.wa_id);
//   //           // setPid(userData.p_id)
//   //         }
//   //       })
//   //       .catch((err) => {
//   //         console.error("Error retrieving user data:", err);
//   //       });
//   //   }, []); // 👈 FIXED — run once only

//   // const [templateOptions, setTemplateOptions] = useState([]);

//   // // Get session user data
//   // useEffect(() => {
//   //   const sessionData = sessionStorage.getItem('user');
//   //   if (sessionData) {
//   //     const user = JSON.parse(sessionData);
//   //     if (user.id) setUserId(user.id);
//   //     if (user.wa_id) {
//   //       setWid(user.wa_id); 
//   //       // fetchTemplates(user.wa_id); // Fetch templates here 
//   //       fetchTemplates(waId)
//   //     }
//   //   }
//   // }, [waId]); 

//   // // Fetch template options
//   // const fetchTemplates = async (waId) => {
//   //   try {
//   //     const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=10&wid=${waId}`);
//   //     const json = await response.json();
//   //     const approvedTemplates = json.data?.filter(item => item.status === "APPROVED") || [];
//   //     setTemplateOptions(approvedTemplates);
//   //   } catch (error) {
//   //     console.error("Failed to fetch templates:", error);
//   //   }
//   // };



// const [waId, setWaId] = useState(null);
// // const [userId, setUserId] = useState(null);
// const [templateOptions, setTemplateOptions] = useState([]);

// /* ---------------------------
//    1️⃣  GET WA_ID BASED ON ROLE
// ----------------------------*/
// useEffect(() => {
//   const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//   if (!loggedUser) return;

//   // ROLE-BASED EMAIL
//   const emailToUse =
//     loggedUser.role === "admin"
//       ? loggedUser.email         // admin → use own email
//       : loggedUser.adminEmail;   // member → use admin's email

//   if (!emailToUse) return;

//   axios
//     .get(
//       `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//         emailToUse
//       )}`
//     )
//     .then((response) => {
//       const userData = response.data;
//       console.log("User Data Fetched:", userData);

//       if (userData?.wa_id) {
//         setWaId(userData.wa_id);
//       }
//     })
//     .catch((err) => {
//       console.error("Error retrieving user data:", err);
//     });
// }, []);

// /* ---------------------------------------
//    2️⃣  GET USER ID BASED ON ROLE
// ----------------------------------------*/
// useEffect(() => {
//   const sessionData = sessionStorage.getItem("user");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   const finalUserId =
//     user.role === "admin"
//       ? user.id       // admin → use id
//       : user.userId;  // member → use userId

//   setUserId(finalUserId);
// }, []);

// /* ---------------------------------------
//    3️⃣  FETCH TEMPLATES WHEN waId IS READY
// ----------------------------------------*/
// useEffect(() => {
//   if (waId) {
//     fetchTemplates(waId);
//   }
// }, [waId]);

// /* ---------------------------------------
//    4️⃣  TEMPLATE FETCH FUNCTION
// ----------------------------------------*/
// const fetchTemplates = async (wid) => {
//   try {
//     const response = await fetch(
//       `https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=10&wid=${wid}`
//     );

//     const json = await response.json();

//     const approvedTemplates =
//       json.data?.filter((item) => item.status === "APPROVED") || [];

//     setTemplateOptions(approvedTemplates);
//   } catch (error) {
//     console.error("Failed to fetch templates:", error);
//   }
// };
//   // Fetch available tables
//   useEffect(() => {
//         const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;

//        const emailToUse =  user.role === "admin" ? user.id : user.userId; // Member → use adminEmail
//     // if (!userId) return;
//     axios.get(`https://botapi.emedha.in/pages/api/api/tables?userId=${emailToUse}`)
//       .then(res => 
//         {
//               const groupsData = res.data;

//       // Filter the groups based on the user role
//         // Filter the groups based on the user role
//       let filteredGroups;
//       if (user.role === "admin") {
//         // Admin sees all groups, including empty role groups
//         filteredGroups = groupsData;
//       } else if (user.role === "member") {
//         // Member only sees their own groups (where member_id matches)
//         filteredGroups = groupsData.filter(group => group.role === "member" && group.member_id === user.id);
//       }
          
//           setTables(filteredGroups)
//         })
//       .catch(err => console.error('Error fetching tables', err));
//   }, [userId]);

//   const handleTableChange = async (e) => {
//     const table = e.target.value;
//     setSelectedTable(table);
//     setMappings([]);

//     try {
//       const res = await axios.get(`https://botapi.emedha.in/pages/api/api/tables/${table}/columns`);
//       const filteredColumns = res.data.filter(
//         col => !DEFAULT_COLUMNS.includes(col) && !PERMANENT_EXCLUDED_COLUMNS.includes(col)
//       );
//       setColumns(filteredColumns);

//       const mapRes = await axios.get(`https://botapi.emedha.in/pages/api/api/column-mapping?temp_name=${tempName}`);
//       if (mapRes.data.length > 0) {
//         const existing = mapRes.data[0].tcolumn;
//         const uiColumns = existing.filter(
//           col => !PERMANENT_EXCLUDED_COLUMNS.includes(col.columnName)
//         );
//         setMappings(uiColumns);
//       } else {
//         const defaultMap = filteredColumns.map(col => ({
//           columnName: col,
//           isStatic: 'N',
//           value: ''
//         }));
//         setMappings(defaultMap);
//       }
//     } catch (err) {
//       console.error('Error loading mapping:', err);
//     }
//   };

//   const handleCheckboxChange = (index) => {
//     const updated = [...mappings];
//     updated[index].isStatic = updated[index].isStatic === 'Y' ? 'N' : 'Y';
//     if (updated[index].isStatic === 'N') updated[index].value = '';
//     setMappings(updated);
//   };

//   const handleValueChange = (index, value) => {
//     const updated = [...mappings];
//     updated[index].value = value;
//     setMappings(updated);
//   };

//   // const handleSubmit = async () => {
//   //   if (!wid) return alert('WID not found in session.');
//   //   if (!tempName) return alert('Please select a template name.');

//   //   const payload = {
//   //     wid,
//   //     temp_name: tempName,
//   //     table_name: selectedTable, // <-- ADD THIS LINE
//   //     tcolumn: mappings
//   //   };

//   //   try {
//   //     await axios.post('https://botapi.emedha.in/pages/api/api/column-mapping', payload);
//   //     alert('Mapping saved successfully!');
//   //   } catch (err) {
//   //     console.error('Error saving mapping', err);
//   //     alert('Failed to save mapping.');
//   //   }
//   // };

//   const handleSubmit = async () => {
//   if (!waId) return alert('WID not found.');
//   if (!tempName) return alert('Please select a template name.');

//   // Get session user
//   const sessionUser = JSON.parse(sessionStorage.getItem("user"));

//   const role = sessionUser?.role || "";
  
//   // ROLE BASED MEMBER ID
//   const member_id = role === "admin"  ? 0   : sessionUser?.id || 0;     // Member → send userId

//   const payload = {
//     wid: waId,
//     temp_name: tempName,
//     table_name: selectedTable,
//     tcolumn: mappings,

//     // ⭐ Add these two
//     role: role,
//     member_id: member_id
//   };

//   console.log("Payload Sent:", payload);

//   try {
//     await axios.post(
//       'https://botapi.emedha.in/pages/api/api/column-mapping',
//       payload
//     );
//     alert('Mapping saved successfully!');
//   } catch (err) {
//     console.error('Error saving mapping', err);
//     alert('Failed to save mapping.');
//   }
// };

//   return (
//     <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '12px', color: '#333', maxWidth: 600, margin: '1rem', padding: '1rem' }}>
//       <h2 style={{ textTransform: 'uppercase', fontSize: '12px', marginBottom: '0.75rem' }}>Column Mapping</h2>

//       {/* Template Dropdown */}
//       <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>Select Template:</label>
//       <select value={tempName} onChange={(e) => setTempName(e.target.value)} style={{ width: '100%', padding: '0.4rem', fontSize: '12px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '1rem' }}>
//         <option value="">-- Select Template --</option>
//         {templateOptions.map((tpl) => (
//           <option key={tpl.id} value={tpl.name}>
//             {tpl.name}
//           </option>
//         ))}
//       </select>

//       {/* Table Dropdown */}
//       <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>
//         Select Table:
//       </label>
//       <select onChange={handleTableChange} value={selectedTable} style={{ width: '100%', padding: '0.4rem', fontSize: '12px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '1rem' }}>
//         <option value="">-- Select Table --</option>
//         {tables.map((tbl) => (
//           <option key={tbl.table_name} value={tbl.table_name}>
//             {tbl.table_name} ({tbl.user_name})
//           </option>
//         ))}
//       </select>

//       {/* Column Mappings */}
//       {mappings.length > 0 && (
//         <div>
//           <h3 style={{ textTransform: 'uppercase', fontSize: '12px', marginBottom: '0.5rem' }}>Map Columns</h3>
//           <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 0.7fr 3fr', gap: '0.75rem', alignItems: 'center', borderTop: '1px solid #ddd', paddingTop: '0.5rem' }}>
//             <div style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>Column Name</div>
//             <div style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>Static</div>
//             <div style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>Value</div>
//             {mappings.map((col, index) => (
//               <React.Fragment key={index}>
//                 <div>{col.columnName}</div>
//                 <div>
//                   <input type="checkbox" checked={col.isStatic === 'Y'} onChange={() => handleCheckboxChange(index)} style={{ transform: 'scale(1.2)', cursor: 'pointer' }} />
//                 </div>
//                 <div>
//                   {col.isStatic === 'Y' ? (
//                     <textarea style={{ width: '100%', minHeight: '50px', resize: 'vertical', fontSize: '12px', fontFamily: 'Arial, sans-serif' }} value={col.value} onChange={(e) => handleValueChange(index, e.target.value)} />
//                   ) : (
//                     <em style={{ color: '#aaa' }}>—</em>
//                   )}
//                 </div>
//               </React.Fragment>
//             ))}
//           </div>
//           <button onClick={handleSubmit} style={{ marginTop: '1rem', padding: '0.4rem 1rem', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', textTransform: 'uppercase' }}>Save Mapping</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ColumnMapping;


// import React, { useState, useEffect } from "react";
// import { Columns, Save, Plus, Trash2, ChevronDown, ChevronUp } from "lucide-react";

// // ─── Theme Colors ────────────────────────────────────────────────────────────
// const theme = {
//   background: "#f8fafc",
//   card: "#ffffff",
//   border: "#e2e8f0",
//   foreground: "#0f172a",
//   mutedForeground: "#64748b",
//   primary: "#2563eb",
//   primaryForeground: "#ffffff",
//   muted: "#f1f5f9",
//   secondary: "#eff6ff",
//   amberBg: "rgba(245, 158, 11, 0.05)",
//   amberBorder: "#fde68a",
//   amberText: "#b45309",
//   amberSolid: "#f59e0b",
//   destructive: "#dc2626",
//   destructiveBg: "#fef2f2",
//   destructiveBorder: "#fca5a5",
//   emerald: "#10b981",
// };

// // ─── Data ─────────────────────────────────────────────────────────────────────
// const TEMPLATES = [
//   "lions_dir",
//   "sudha_tom1",
//   "sudha_tom",
//   "sudha_update1",
//   "sudha_tel",
//   "appointment_reminder",
//   "lab_result_alert",
//   "prescription_renew",
// ];

// const TABLES = [
//   "tbl_vj_26154406 (emedhatechnologies@gmail.com)",
//   "tbl_sudhaupdate_26143318 (emedhatechnologies@gmail.com)",
//   "tbl_sud108_26093026 (emedhatechnologies@gmail.com)",
//   "tbl_lbnstall_26130832 (emedhatechnologies@gmail.com)",
//   "tbl_fvdg2526_26175441 (emedhatechnologies@gmail.com)",
//   "tbl_test1234_26224621 (emedhatechnologies@gmail.com)",
//   "tbl_member_25124914 (emedhatechnologies@gmail.com)",
// ];

// const TEMPLATE_COLUMNS = {
//   lions_dir:           ["cl_msg", "cl_name", "cl_phone", "cl_district", "cl_club"],
//   sudha_tom1:          ["cl_msg", "cl_name", "cl_mobile"],
//   sudha_tom:           ["cl_msg", "cl_patient_name", "cl_date"],
//   sudha_update1:       ["cl_msg", "cl_name", "cl_update_type"],
//   sudha_tel:           ["cl_msg", "cl_name"],
//   appointment_reminder: ["cl_msg", "cl_patient", "cl_doctor", "cl_time", "cl_date"],
//   lab_result_alert:     ["cl_msg", "cl_patient", "cl_lab_ref"],
//   prescription_renew:   ["cl_msg", "cl_patient", "cl_medicine", "cl_expiry"],
// };

// // ─── Dropdown Component ──────────────────────────────────────────────────────
// function Dropdown({ label, value, options, onChange, placeholder }) {
//   const [open, setOpen] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);

//   return (
//     <div style={{ flex: 1, minWidth: "200px" }}>
//       <p style={{ fontSize: "12px", fontWeight: "600", color: theme.foreground, marginBottom: "6px" }}>
//         {label}
//       </p>
//       <div style={{ position: "relative" }}>
//         <button
//           type="button"
//           onClick={() => setOpen((v) => !v)}
//           onMouseEnter={() => setIsHovered(true)}
//           onMouseLeave={() => setIsHovered(false)}
//           style={{
//             width: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             padding: "10px 12px",
//             borderRadius: "8px",
//             border: `1px solid ${isHovered || open ? theme.primary : theme.border}`,
//             backgroundColor: theme.card,
//             fontSize: "14px",
//             textAlign: "left",
//             cursor: "pointer",
//             transition: "all 0.2s ease",
//             outline: "none",
//           }}
//         >
//           <span
//             style={{
//               color: value ? theme.foreground : theme.mutedForeground,
//               fontWeight: value ? "500" : "400",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {value || placeholder || `Select ${label}`}
//           </span>
//           {open ? (
//             <ChevronUp size={14} style={{ color: theme.mutedForeground, flexShrink: 0, marginLeft: "8px" }} />
//           ) : (
//             <ChevronDown size={14} style={{ color: theme.mutedForeground, flexShrink: 0, marginLeft: "8px" }} />
//           )}
//         </button>

//         {open && (
//           <div
//             style={{
//               position: "absolute",
//               zIndex: 20,
//               top: "100%",
//               marginTop: "4px",
//               width: "100%",
//               backgroundColor: theme.card,
//               border: `1px solid ${theme.border}`,
//               borderRadius: "12px",
//               boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
//               overflow: "hidden",
//               maxHeight: "208px",
//               overflowY: "auto",
//             }}
//           >
//             {options.map((opt) => {
//               const isSelected = value === opt;
//               return (
//                 <button
//                   key={opt}
//                   type="button"
//                   onClick={() => {
//                     onChange(opt);
//                     setOpen(false);
//                   }}
//                   style={{
//                     width: "100%",
//                     textAlign: "left",
//                     padding: "10px 12px",
//                     fontSize: "14px",
//                     border: "none",
//                     cursor: "pointer",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                     transition: "colors 0.2s ease",
//                     backgroundColor: isSelected ? theme.secondary : "transparent",
//                     color: isSelected ? theme.primary : theme.foreground,
//                     fontWeight: isSelected ? "500" : "400",
//                   }}
//                   onMouseEnter={(e) => {
//                     if (!isSelected) e.currentTarget.style.backgroundColor = theme.muted;
//                   }}
//                   onMouseLeave={(e) => {
//                     if (!isSelected) e.currentTarget.style.backgroundColor = "transparent";
//                   }}
//                 >
//                   {opt}
//                 </button>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function ColumnMapping() {
//   const [template, setTemplate] = useState("");
//   const [table, setTable] = useState("");
//   const [rows, setRows] = useState([]);
//   const [saved, setSaved] = useState(false);
//   const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);

//   // Responsive state logic mapping to Tailwind's 'sm' breakpoint (640px)
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const isMobile = windowWidth < 640;

//   const handleTemplateChange = (tpl) => {
//     setTemplate(tpl);
//     setSaved(false);
//     const cols = TEMPLATE_COLUMNS[tpl] ?? [];
//     setRows(
//       cols.map((col) => ({
//         id: col,
//         columnName: col,
//         isStatic: false,
//         staticValue: "",
//         tableColumn: "",
//       }))
//     );
//   };

//   const updateRow = (id, patch) => {
//     setRows((prev) => prev.map((r) => (r.id === id ? { ...r, ...patch } : r)));
//     setSaved(false);
//   };

//   const toggleStatic = (id) => {
//     setRows((prev) =>
//       prev.map((r) =>
//         r.id === id
//           ? { ...r, isStatic: !r.isStatic, staticValue: r.isStatic ? "" : r.staticValue }
//           : r
//       )
//     );
//     setSaved(false);
//   };

//   const addRow = () => {
//     const newId = `custom_${Date.now()}`;
//     setRows((prev) => [...prev, { id: newId, columnName: "", isStatic: false, staticValue: "", tableColumn: "" }]);
//   };

//   const removeRow = (id) => {
//     setRows((prev) => prev.filter((r) => r.id !== id));
//   };

//   const handleSave = () => {
//     if (!template || !table) return;
//     setSaved(true);
//     setTimeout(() => setSaved(false), 3000);
//   };

//   const isReady = template && table && rows.length > 0;

//   return (
//     <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "24px", fontFamily: "sans-serif" }}>
//       {/* Page Header Emulation */}
//       <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" }}>
//         <div style={{ padding: "10px", backgroundColor: theme.secondary, borderRadius: "8px", color: theme.primary }}>
//           <Columns size={24} />
//         </div>
//         <div>
//           <h1 style={{ fontSize: "24px", fontWeight: "700", color: theme.foreground, margin: 0 }}>Column Mapping</h1>
//           <p style={{ fontSize: "14px", color: theme.mutedForeground, margin: "4px 0 0 0" }}>
//             Map template variables to table columns or static values
//           </p>
//         </div>
//       </div>

//       {/* ── Step 1: Select Template & Table ── */}
//       <div
//         style={{
//           backgroundColor: theme.card,
//           borderRadius: "12px",
//           border: `1px solid ${theme.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//           padding: "20px",
//           marginBottom: "24px",
//         }}
//       >
//         <p
//           style={{
//             fontSize: "12px",
//             fontWeight: "700",
//             color: theme.mutedForeground,
//             textTransform: "uppercase",
//             letterSpacing: "0.05em",
//             marginBottom: "16px",
//             marginUp: 0,
//           }}
//         >
//           Step 1 — Select Source
//         </p>
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
//             gap: "16px",
//           }}
//         >
//           <Dropdown
//             label="Select Template"
//             value={template}
//             options={TEMPLATES}
//             onChange={handleTemplateChange}
//           />
//           <Dropdown
//             label="Select Table"
//             value={table}
//             options={TABLES}
//             onChange={(v) => {
//               setTable(v);
//               setSaved(false);
//             }}
//           />
//         </div>
//       </div>

//       {/* ── Step 2: Map Columns ── */}
//       {rows.length > 0 && (
//         <div
//           style={{
//             backgroundColor: theme.card,
//             borderRadius: "12px",
//             border: `1px solid ${theme.border}`,
//             boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//             overflow: "hidden",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               padding: "14px 20px",
//               borderBottom: `1px solid ${theme.border}`,
//               backgroundColor: "rgba(241, 245, 249, 0.3)",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//               <Columns size={14} style={{ color: theme.primary }} />
//               <p style={{ fontSize: "14px", fontWeight: "700", color: theme.foreground, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
//                 Map Columns
//               </p>
//             </div>
//             <button
//               onClick={addRow}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "6px",
//                 padding: "6px 12px",
//                 borderRadius: "8px",
//                 border: `1px solid ${theme.border}`,
//                 backgroundColor: theme.card,
//                 fontSize: "12px",
//                 fontWeight: "500",
//                 color: theme.foreground,
//                 cursor: "pointer",
//                 transition: "all 0.2s",
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.backgroundColor = theme.muted;
//                 e.currentTarget.style.color = theme.primary;
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.backgroundColor = theme.card;
//                 e.currentTarget.style.color = theme.foreground;
//               }}
//             >
//               <Plus size={12} /> Add Row
//             </button>
//           </div>

//           {/* Desktop Table View */}
//           {!isMobile && (
//             <div style={{ overflowX: "auto" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                   <tr style={{ borderBottom: `1px solid ${theme.border}`, backgroundColor: "rgba(241, 245, 249, 0.4)" }}>
//                     <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", trackingWidth: "0.05em", width: "200px" }}>Column Name</th>
//                     <th style={{ textAlign: "center", padding: "12px 16px", fontSize: "11px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", trackingWidth: "0.05em", width: "90px" }}>Static</th>
//                     <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", trackingWidth: "0.05em" }}>Value</th>
//                     <th style={{ padding: "12px 16px", width: "48px" }} />
//                   </tr>
//                 </thead>
//                 <tbody style={{ divideY: `1px solid ${theme.border}` }}>
//                   {rows.map((row) => (
//                     <tr
//                       key={row.id}
//                       style={{
//                         borderBottom: `1px solid ${theme.border}`,
//                         backgroundColor: row.isStatic ? theme.amberBg : "transparent",
//                         transition: "background-color 0.2s",
//                       }}
//                     >
//                       {/* Column Name */}
//                       <td style={{ padding: "12px 20px" }}>
//                         <input
//                           type="text"
//                           value={row.columnName}
//                           onChange={(e) => updateRow(row.id, { columnName: e.target.value })}
//                           placeholder="column_name"
//                           style={{
//                             width: "100%",
//                             padding: "6px 10px",
//                             fontSize: "12px",
//                             borderRadius: "8px",
//                             border: `1px solid ${theme.border}`,
//                             backgroundColor: theme.card,
//                             color: theme.foreground,
//                             fontFamily: "monospace",
//                             outline: "none",
//                             boxSizing: "border-box"
//                           }}
//                         />
//                       </td>

//                       {/* Static Checkbox Switch */}
//                       <td style={{ padding: "12px 16px", textAlign: "center" }}>
//                         <label style={{ inlineFlex: "true", alignItems: "center", justifyContent: "center", cursor: "pointer", display: "inline-block" }}>
//                           <input
//                             type="checkbox"
//                             checked={row.isStatic}
//                             onChange={() => toggleStatic(row.id)}
//                             style={{ display: "none" }}
//                           />
//                           <div
//                             style={{
//                               width: "36px",
//                               height: "20px",
//                               borderRadius: "9999px",
//                               position: "relative",
//                               transition: "all 0.2s",
//                               backgroundColor: row.isStatic ? theme.amberSolid : theme.muted,
//                               border: row.isStatic ? "none" : `1px solid ${theme.border}`,
//                             }}
//                           >
//                             <div
//                               style={{
//                                 position: "absolute",
//                                 top: "2px",
//                                 left: row.isStatic ? "18px" : "2px",
//                                 width: "16px",
//                                 height: "16px",
//                                 borderRadius: "50%",
//                                 backgroundColor: "#ffffff",
//                                 boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                 transition: "all 0.2s",
//                               }}
//                             />
//                           </div>
//                         </label>
//                       </td>

//                       {/* Value Field */}
//                       <td style={{ padding: "12px 20px" }}>
//                         {row.isStatic ? (
//                           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                             <span
//                               style={{
//                                 fontSize: "10px",
//                                 fontWeight: "600",
//                                 color: theme.amberText,
//                                 backgroundColor: "rgba(245, 158, 11, 0.1)",
//                                 border: `1px solid ${theme.amberBorder}`,
//                                 padding: "2px 8px",
//                                 borderRadius: "9999px",
//                                 whiteSpace: "nowrap",
//                               }}
//                             >
//                               Static Value
//                             </span>
//                             <input
//                               type="text"
//                               value={row.staticValue}
//                               onChange={(e) => updateRow(row.id, { staticValue: e.target.value })}
//                               placeholder="Enter static value..."
//                               autoFocus
//                               style={{
//                                 flex: 1,
//                                 padding: "6px 12px",
//                                 fontSize: "12px",
//                                 borderRadius: "8px",
//                                 border: `1px solid #f59e0b`,
//                                 backgroundColor: "rgba(245, 158, 11, 0.05)",
//                                 color: theme.foreground,
//                                 outline: "none",
//                                 fontWeight: "500",
//                                 boxSizing: "border-box"
//                               }}
//                             />
//                           </div>
//                         ) : (
//                           <input
//                             type="text"
//                             value={row.tableColumn}
//                             onChange={(e) => updateRow(row.id, { tableColumn: e.target.value })}
//                             placeholder="Table column name or —"
//                             style={{
//                               width: "100%",
//                               padding: "6px 10px",
//                               fontSize: "12px",
//                               borderRadius: "8px",
//                               border: `1px solid ${theme.border}`,
//                               backgroundColor: theme.card,
//                               color: theme.foreground,
//                               fontFamily: "monospace",
//                               outline: "none",
//                               boxSizing: "border-box"
//                             }}
//                           />
//                         )}
//                       </td>

//                       {/* Delete Button */}
//                       <td style={{ padding: "12px 16px" }}>
//                         <button
//                           onClick={() => removeRow(row.id)}
//                           style={{
//                             width: "28px",
//                             height: "28px",
//                             borderRadius: "8px",
//                             border: `1px solid ${theme.border}`,
//                             backgroundColor: "transparent",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             color: theme.mutedForeground,
//                             cursor: "pointer",
//                             transition: "all 0.2s",
//                           }}
//                           onMouseEnter={(e) => {
//                             e.currentTarget.style.color = theme.destructive;
//                             e.currentTarget.style.borderColor = theme.destructiveBorder;
//                             e.currentTarget.style.backgroundColor = theme.destructiveBg;
//                           }}
//                           onMouseLeave={(e) => {
//                             e.currentTarget.style.color = theme.mutedForeground;
//                             e.currentTarget.style.borderColor = theme.border;
//                             e.currentTarget.style.backgroundColor = "transparent";
//                           }}
//                         >
//                           <Trash2 size={12} />
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           {/* Mobile Card Layout View */}
//           {isMobile && (
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               {rows.map((row) => (
//                 <div
//                   key={row.id}
//                   style={{
//                     padding: "16px",
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "12px",
//                     borderBottom: `1px solid ${theme.border}`,
//                     backgroundColor: row.isStatic ? theme.amberBg : "transparent",
//                   }}
//                 >
//                   {/* Column Name */}
//                   <div>
//                     <p style={{ fontSize: "10px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", letterSpacing: "0.05em", margin: "0 0 4px 0" }}>
//                       Column Name
//                     </p>
//                     <input
//                       type="text"
//                       value={row.columnName}
//                       onChange={(e) => updateRow(row.id, { columnName: e.target.value })}
//                       placeholder="column_name"
//                       style={{
//                         width: "100%",
//                         padding: "8px",
//                         fontSize: "12px",
//                         borderRadius: "8px",
//                         border: `1px solid ${theme.border}`,
//                         backgroundColor: theme.card,
//                         color: theme.foreground,
//                         fontFamily: "monospace",
//                         outline: "none",
//                         boxSizing: "border-box"
//                       }}
//                     />
//                   </div>

//                   {/* Static Toggle */}
//                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <div>
//                       <p style={{ fontSize: "12px", fontWeight: "600", color: theme.foreground, margin: 0 }}>Static Value</p>
//                       <p style={{ fontSize: "11px", color: theme.mutedForeground, margin: 0 }}>Toggle to enter a fixed value</p>
//                     </div>
//                     <label style={{ display: "inline-block", cursor: "pointer" }}>
//                       <input type="checkbox" checked={row.isStatic} onChange={() => toggleStatic(row.id)} style={{ display: "none" }} />
//                       <div
//                         style={{
//                           width: "40px",
//                           height: "20px",
//                           borderRadius: "9999px",
//                           position: "relative",
//                           transition: "all 0.2s",
//                           backgroundColor: row.isStatic ? theme.amberSolid : theme.muted,
//                           border: row.isStatic ? "none" : `1px solid ${theme.border}`,
//                         }}
//                       >
//                         <div
//                           style={{
//                             position: "absolute",
//                             top: "2px",
//                             left: row.isStatic ? "22px" : "2px",
//                             width: "16px",
//                             height: "16px",
//                             borderRadius: "50%",
//                             backgroundColor: "#ffffff",
//                             boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                             transition: "all 0.2s",
//                           }}
//                         />
//                       </div>
//                     </label>
//                   </div>

//                   {/* Value inputs */}
//                   {row.isStatic ? (
//                     <div>
//                       <p style={{ fontSize: "10px", fontWeight: "600", color: theme.amberText, textTransform: "uppercase", letterSpacing: "0.05em", margin: "0 0 4px 0" }}>
//                         Static Value
//                       </p>
//                       <input
//                         type="text"
//                         value={row.staticValue}
//                         onChange={(e) => updateRow(row.id, { staticValue: e.target.value })}
//                         placeholder="Enter static value..."
//                         style={{
//                           width: "100%",
//                           padding: "8px",
//                           fontSize: "12px",
//                           borderRadius: "8px",
//                           border: `1px solid ${theme.amberBorder}`,
//                           backgroundColor: "rgba(245, 158, 11, 0.05)",
//                           color: theme.foreground,
//                           outline: "none",
//                           boxSizing: "border-box"
//                         }}
//                       />
//                     </div>
//                   ) : (
//                     <div>
//                       <p style={{ fontSize: "10px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", letterSpacing: "0.05em", margin: "0 0 4px 0" }}>
//                         Table Column
//                       </p>
//                       <input
//                         type="text"
//                         value={row.tableColumn}
//                         onChange={(e) => updateRow(row.id, { tableColumn: e.target.value })}
//                         placeholder="Table column name or —"
//                         style={{
//                           width: "100%",
//                           padding: "8px",
//                           fontSize: "12px",
//                           borderRadius: "8px",
//                           border: `1px solid ${theme.border}`,
//                           backgroundColor: theme.card,
//                           color: theme.foreground,
//                           fontFamily: "monospace",
//                           outline: "none",
//                           boxSizing: "border-box"
//                         }}
//                       />
//                     </div>
//                   )}

//                   <button
//                     onClick={() => removeRow(row.id)}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "4px",
//                       fontSize: "12px",
//                       color: theme.destructive,
//                       border: "none",
//                       backgroundColor: "transparent",
//                       cursor: "pointer",
//                       padding: 0,
//                       marginTop: "4px"
//                     }}
//                   >
//                     <Trash2 size={12} /> Remove row
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Legend */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               padding: "12px 20px",
//               borderTop: `1px solid ${theme.border}`,
//               backgroundColor: "rgba(241, 245, 249, 0.2)",
//               fontSize: "11px",
//               color: theme.mutedForeground,
//             }}
//           >
//             <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//               <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: theme.muted, border: `1px solid ${theme.border}`, display: "inline-block" }} /> Dynamic (from table column)
//             </span>
//             <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//               <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: theme.amberSolid, display: "inline-block" }} /> Static (fixed value)
//             </span>
//           </div>

//           {/* Save Footer */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               padding: "14px 20px",
//               borderTop: `1px solid ${theme.border}`,
//             }}
//           >
//             <p style={{ fontSize: "12px", color: theme.mutedForeground, margin: 0 }}>
//               {rows.filter((r) => r.isStatic).length} static · {rows.filter((r) => !r.isStatic).length} dynamic
//             </p>
//             <button
//               onClick={handleSave}
//               disabled={!isReady}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 padding: "10px 16px",
//                 borderRadius: "8px",
//                 fontSize: "14px",
//                 fontWeight: "600",
//                 border: "none",
//                 cursor: isReady ? "pointer" : "not-allowed",
//                 transition: "all 0.2s",
//                 backgroundColor: isReady ? (saved ? theme.emerald : theme.primary) : theme.muted,
//                 color: isReady ? theme.primaryForeground : theme.mutedForeground,
//                 boxShadow: isReady ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
//               }}
//             >
//               {saved ? (
//                 <>
//                   <span style={{ width: "16px", height: "16px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.3)", display: "flex", alignItems: "center", justifyContext: "center", fontSize: "10px" }}>✓</span>
//                   Saved!
//                 </>
//               ) : (
//                 <>
//                   <Save size={14} /> Save Mapping
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Empty State Container */}
//       {!template && (
//         <div
//           style={{
//             backgroundColor: theme.card,
//             borderRadius: "12px",
//             border: `1px solid ${theme.border}`,
//             padding: "40px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "12px",
//             textAlign: "center",
//             boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//           }}
//         >
//           <div style={{ width: "48px", height: "48px", borderRadius: "16px", backgroundColor: theme.muted, display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <Columns size={22} style={{ color: theme.mutedForeground }} />
//           </div>
//           <p style={{ fontSize: "14px", fontWeight: "600", color: theme.foreground, margin: 0 }}>Select a template to begin</p>
//           <p style={{ fontSize: "12px", color: theme.mutedForeground, maxWidth: "320px", margin: 0, lineHeight: "1.5" }}>
//             Choose a template above and the column list will load automatically based on its variables.
//           </p>
//         </div>
//       )}
//     </div>
//   );
// }



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Columns, Save, ChevronDown, ChevronUp } from 'lucide-react';

const PERMANENT_EXCLUDED_COLUMNS = ['id', 'name', 'mobile', 'groupid', 'subgroupid'];
const DEFAULT_COLUMNS = ['group_id', 'subgroup_id', 'flag', 'user_id'];

// ─── Theme Colors ────────────────────────────────────────────────────────────
const theme = {
  background: "#f8fafc",
  card: "#ffffff",
  border: "#e2e8f0",
  foreground: "#0f172a",
  mutedForeground: "#64748b",
  primary: "#2563eb",
  primaryForeground: "#ffffff",
  muted: "#f1f5f9",
  secondary: "#eff6ff",
  amberBg: "rgba(245, 158, 11, 0.05)",
  amberBorder: "#fde68a",
  amberText: "#b45309",
  amberSolid: "#f59e0b",
  destructive: "#dc2626",
  destructiveBg: "#fef2f2",
  destructiveBorder: "#fca5a5",
  emerald: "#10b981",
};

// ─── Styled Custom Dropdown Component ─────────────────────────────────────────
function CustomDropdown({ label, value, options, onChange, placeholder, displayKey, valueKey }) {
  const [open, setOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={{ flex: 1, minWidth: "200px" }}>
      <p style={{ fontSize: "12px", fontWeight: "600", color: theme.foreground, marginBottom: "6px" }}>
        {label}
      </p>
      <div style={{ position: "relative" }}>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 12px",
            borderRadius: "8px",
            border: `1px solid ${isHovered || open ? theme.primary : theme.border}`,
            backgroundColor: theme.card,
            fontSize: "14px",
            textAlign: "left",
            cursor: "pointer",
            transition: "all 0.2s ease",
            outline: "none",
          }}
        >
          <span
            style={{
              color: value ? theme.foreground : theme.mutedForeground,
              fontWeight: value ? "500" : "400",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {value || placeholder || `Select ${label}`}
          </span>
          {open ? (
            <ChevronUp size={14} style={{ color: theme.mutedForeground, flexShrink: 0, marginLeft: "8px" }} />
          ) : (
            <ChevronDown size={14} style={{ color: theme.mutedForeground, flexShrink: 0, marginLeft: "8px" }} />
          )}
        </button>

        {open && (
          <div
            style={{
              position: "absolute",
              zIndex: 20,
              top: "100%",
              marginTop: "4px",
              width: "100%",
              backgroundColor: theme.card,
              border: `1px solid ${theme.border}`,
              borderRadius: "12px",
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
              overflow: "hidden",
              maxHeight: "208px",
              overflowY: "auto",
            }}
          >
            {options.map((opt, index) => {
              const optVal = valueKey ? opt[valueKey] : opt;
              const optDisplay = displayKey ? (typeof displayKey === 'function' ? displayKey(opt) : opt[displayKey]) : opt;
              const isSelected = value === optVal;
              return (
                <button
                  key={index}
                  type="button"
                  onClick={() => {
                    onChange(optVal);
                    setOpen(false);
                  }}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    padding: "10px 12px",
                    fontSize: "14px",
                    border: "none",
                    cursor: "pointer",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    transition: "colors 0.2s ease",
                    backgroundColor: isSelected ? theme.secondary : "transparent",
                    color: isSelected ? theme.primary : theme.foreground,
                    fontWeight: isSelected ? "500" : "400",
                  }}
                  onMouseEnter={(e) => {
                    if (!isSelected) e.currentTarget.style.backgroundColor = theme.muted;
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected) e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  {optDisplay}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
const ColumnMapping = () => {
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [columns, setColumns] = useState([]);
  const [mappings, setMappings] = useState([]);
  const [tempName, setTempName] = useState('');

  const [userId, setUserId] = useState('');
  const [waId, setWaId] = useState(null);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);

  // Responsive logic tracking for layouts
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 640;

  /* ---------------------------
     1️⃣  GET WA_ID BASED ON ROLE
  ----------------------------*/
  useEffect(() => {
    const loggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loggedUser) return;

    const emailToUse =
      loggedUser.role === "admin"
        ? loggedUser.email
        : loggedUser.adminEmail;

    if (!emailToUse) return;

    axios
      .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
      .then((response) => {
        const userData = response.data;
        console.log("User Data Fetched:", userData);

        if (userData?.wa_id) {
          setWaId(userData.wa_id);
        }
      })
      .catch((err) => {
        console.error("Error retrieving user data:", err);
      });
  }, []);

  /* ---------------------------------------
     2️⃣  GET USER ID BASED ON ROLE
  ----------------------------------------*/
  useEffect(() => {
    const sessionData = sessionStorage.getItem("user");
    if (!sessionData) return;

    const user = JSON.parse(sessionData);

    const finalUserId =
      user.role === "admin"
        ? user.id
        : user.userId;

    setUserId(finalUserId);
  }, []);

  /* ---------------------------------------
     3️⃣  FETCH TEMPLATES WHEN waId IS READY
  ----------------------------------------*/
  useEffect(() => {
    if (waId) {
      fetchTemplates(waId);
    }
  }, [waId]);

  /* ---------------------------------------
     4️⃣  TEMPLATE FETCH FUNCTION
  ----------------------------------------*/
  const fetchTemplates = async (wid) => {
    try {
      const response = await fetch(
        `https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=10&wid=${wid}`
      );
      const json = await response.json();
      const approvedTemplates =
        json.data?.filter((item) => item.status === "APPROVED") || [];
      setTemplateOptions(approvedTemplates);
    } catch (error) {
      console.error("Failed to fetch templates:", error);
    }
  };

  // Fetch available tables
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user) return;

    const emailToUse = user.role === "admin" ? user.id : user.userId;
    axios.get(`https://botapi.emedha.in/pages/api/api/tables?userId=${emailToUse}`)
      .then(res => {
        const groupsData = res.data;
        let filteredGroups;
        if (user.role === "admin") {
          filteredGroups = groupsData;
        } else if (user.role === "member") {
          filteredGroups = groupsData.filter(group => group.role === "member" && group.member_id === user.id);
        }
        setTables(filteredGroups);
      })
      .catch(err => console.error('Error fetching tables', err));
  }, [userId]);

  const handleTableChange = async (value) => {
    const table = value;
    setSelectedTable(table);
    setMappings([]);

    try {
      const res = await axios.get(`https://botapi.emedha.in/pages/api/api/tables/${table}/columns`);
      const filteredColumns = res.data.filter(
        col => !DEFAULT_COLUMNS.includes(col) && !PERMANENT_EXCLUDED_COLUMNS.includes(col)
      );
      setColumns(filteredColumns);

      const mapRes = await axios.get(`https://botapi.emedha.in/pages/api/api/column-mapping?temp_name=${tempName}`);
      if (mapRes.data.length > 0) {
        const existing = mapRes.data[0].tcolumn;
        const uiColumns = existing.filter(
          col => !PERMANENT_EXCLUDED_COLUMNS.includes(col.columnName)
        );
        setMappings(uiColumns);
      } else {
        const defaultMap = filteredColumns.map(col => ({
          columnName: col,
          isStatic: 'N',
          value: ''
        }));
        setMappings(defaultMap);
      }
    } catch (err) {
      console.error('Error loading mapping:', err);
    }
  };

  const handleCheckboxChange = (index) => {
    const updated = [...mappings];
    updated[index].isStatic = updated[index].isStatic === 'Y' ? 'N' : 'Y';
    if (updated[index].isStatic === 'N') updated[index].value = '';
    setMappings(updated);
  };

  const handleValueChange = (index, value) => {
    const updated = [...mappings];
    updated[index].value = value;
    setMappings(updated);
  };

  const handleSubmit = async () => {
    if (!waId) return alert('WID not found.');
    if (!tempName) return alert('Please select a template name.');

    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    const role = sessionUser?.role || "";
    const member_id = role === "admin" ? 0 : sessionUser?.id || 0;

    const payload = {
      wid: waId,
      temp_name: tempName,
      table_name: selectedTable,
      tcolumn: mappings,
      role: role,
      member_id: member_id
    };

    console.log("Payload Sent:", payload);

    try {
      await axios.post('https://botapi.emedha.in/pages/api/api/column-mapping', payload);
      alert('Mapping saved successfully!');
    } catch (err) {
      console.error('Error saving mapping', err);
      alert('Failed to save mapping.');
    }
  };

  const isReady = tempName && selectedTable && mappings.length > 0;

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto",  fontFamily: "sans-serif" }}>
      {/* Page Header */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" }}>
        <div style={{ padding: "10px", backgroundColor: theme.secondary, borderRadius: "8px", color: theme.primary }}>
          <Columns size={24} />
        </div>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: theme.foreground, margin: 0 }}>Column Mapping</h1>
          <p style={{ fontSize: "14px", color: theme.mutedForeground, margin: "4px 0 0 0" }}>
            Map template variables to table columns or static values
          </p>
        </div>
      </div>

      {/* ── Step 1: Select Template & Table ── */}
      <div
        style={{
          backgroundColor: theme.card,
          borderRadius: "12px",
          border: `1px solid ${theme.border}`,
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          padding: "20px",
          marginBottom: "24px",
        }}
      >
        <p
          style={{
            fontSize: "12px",
            fontWeight: "700",
            color: theme.mutedForeground,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            marginBottom: "16px",
            marginTop: 0,
          }}
        >
          Step 1 — Select Source
        </p>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "16px" }}>
          <CustomDropdown
            label="Select Template"
            value={tempName}
            options={templateOptions}
            onChange={(val) => setTempName(val)}
            placeholder="Select Template"
            displayKey="name"
            valueKey="name"
          />
          <CustomDropdown
            label="Select Table"
            value={selectedTable}
            options={tables}
            onChange={handleTableChange}
            placeholder="Select Table"
            displayKey={(tbl) => `${tbl.table_name} (${tbl.user_name})`}
            valueKey="table_name"
          />
        </div>
      </div>

      {/* ── Step 2: Map Columns ── */}
      {/* {mappings.length > 0 && ( */}
       {tempName && (
        <div
          style={{
            backgroundColor: theme.card,
            borderRadius: "12px",
            border: `1px solid ${theme.border}`,
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "between",
              padding: "14px 20px",
              borderBottom: `1px solid ${theme.border}`,
              backgroundColor: "rgba(241, 245, 249, 0.3)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Columns size={14} style={{ color: theme.primary }} />
              <p style={{ fontSize: "14px", fontWeight: "700", color: theme.foreground, margin: 0 }}>
                Map Columns
              </p>
            </div>
          </div>

          {/* Desktop Table View */}
          {!isMobile && (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ borderBottom: `1px solid ${theme.border}`, backgroundColor: "rgba(241, 245, 249, 0.4)" }}>
                    <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", width: "200px" }}>Column Name</th>
                    <th style={{ textAlign: "center", padding: "12px 16px", fontSize: "11px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", width: "90px" }}>Static</th>
                    <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase" }}>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {mappings.map((col, index) => {
                    const isStaticActive = col.isStatic === 'Y';
                    return (
                      <tr
                        key={index}
                        style={{
                          borderBottom: `1px solid ${theme.border}`,
                          backgroundColor: isStaticActive ? theme.amberBg : "transparent",
                          transition: "background-color 0.2s",
                        }}
                      >
                        {/* Column Name */}
                        <td style={{ padding: "12px 20px", fontSize: "13px", fontWeight: "500", color: theme.foreground, fontFamily: "monospace" }}>
                          {col.columnName}
                        </td>

                        {/* Static Switch Toggle */}
                        <td style={{ padding: "12px 16px", textAlign: "center" }}>
                          <label style={{ display: "inline-block", cursor: "pointer", verticalAlign: "middle" }}>
                            <input
                              type="checkbox"
                              checked={isStaticActive}
                              onChange={() => handleCheckboxChange(index)}
                              style={{ display: "none" }}
                            />
                            <div
                              style={{
                                width: "36px",
                                height: "20px",
                                borderRadius: "9999px",
                                position: "relative",
                                transition: "all 0.2s",
                                backgroundColor: isStaticActive ? theme.amberSolid : theme.muted,
                                border: isStaticActive ? "none" : `1px solid ${theme.border}`,
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: "2px",
                                  left: isStaticActive ? "18px" : "2px",
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  backgroundColor: "#ffffff",
                                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                  transition: "all 0.2s",
                                }}
                              />
                            </div>
                          </label>
                        </td>

                        {/* Value Input Area */}
                        <td style={{ padding: "12px 20px" }}>
                          {isStaticActive ? (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <span
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "600",
                                  color: theme.amberText,
                                  backgroundColor: "rgba(245, 158, 11, 0.1)",
                                  border: `1px solid ${theme.amberBorder}`,
                                  padding: "2px 8px",
                                  borderRadius: "9999px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Static Value
                              </span>
                              <textarea
                                value={col.value}
                                onChange={(e) => handleValueChange(index, e.target.value)}
                                placeholder="Enter static value..."
                                style={{
                                  flex: 1,
                                  padding: "8px 12px",
                                  fontSize: "13px",
                                  borderRadius: "8px",
                                  border: `1px solid ${theme.amberSolid}`,
                                  backgroundColor: "rgba(245, 158, 11, 0.02)",
                                  color: theme.foreground,
                                  outline: "none",
                                  minHeight: "44px",
                                  resize: "vertical",
                                  fontFamily: "sans-serif",
                                  boxSizing: "border-box"
                                }}
                              />
                            </div>
                          ) : (
                            <em style={{ color: theme.mutedForeground, fontSize: "13px" }}>— (Dynamic from table column)</em>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Mobile View Card Layout */}
          {isMobile && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {mappings.map((col, index) => {
                const isStaticActive = col.isStatic === 'Y';
                return (
                  <div
                    key={index}
                    style={{
                      padding: "16px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      borderBottom: `1px solid ${theme.border}`,
                      backgroundColor: isStaticActive ? theme.amberBg : "transparent",
                    }}
                  >
                    <div>
                      <p style={{ fontSize: "10px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", margin: "0 0 4px 0" }}>
                        Column Name
                      </p>
                      <div style={{ fontSize: "14px", fontWeight: "600", color: theme.foreground, fontFamily: "monospace" }}>
                        {col.columnName}
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", justifyContext: "space-between", justifyContent: "space-between" }}>
                      <div>
                        <p style={{ fontSize: "12px", fontWeight: "600", color: theme.foreground, margin: 0 }}>Static Value</p>
                        <p style={{ fontSize: "11px", color: theme.mutedForeground, margin: 0 }}>Toggle to enter fixed static content</p>
                      </div>
                      <label style={{ display: "inline-block", cursor: "pointer" }}>
                        <input
                          type="checkbox"
                          checked={isStaticActive}
                          onChange={() => handleCheckboxChange(index)}
                          style={{ display: "none" }}
                        />
                        <div
                          style={{
                            width: "40px",
                            height: "20px",
                            borderRadius: "9999px",
                            position: "relative",
                            transition: "all 0.2s",
                            backgroundColor: isStaticActive ? theme.amberSolid : theme.muted,
                            border: isStaticActive ? "none" : `1px solid ${theme.border}`,
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "2px",
                              left: isStaticActive ? "22px" : "2px",
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              backgroundColor: "#ffffff",
                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                              transition: "all 0.2s",
                            }}
                          />
                        </div>
                      </label>
                    </div>

                    <div>
                      {isStaticActive ? (
                        <>
                          <p style={{ fontSize: "10px", fontWeight: "600", color: theme.amberText, textTransform: "uppercase", margin: "0 0 4px 0" }}>
                            Static Custom Content
                          </p>
                          <textarea
                            value={col.value}
                            onChange={(e) => handleValueChange(index, e.target.value)}
                            placeholder="Enter static value..."
                            style={{
                              width: "100%",
                              padding: "8px",
                              fontSize: "13px",
                              borderRadius: "8px",
                              border: `1px solid ${theme.amberBorder}`,
                              backgroundColor: theme.card,
                              color: theme.foreground,
                              outline: "none",
                              minHeight: "56px",
                              resize: "vertical",
                              boxSizing: "border-box"
                            }}
                          />
                        </>
                      ) : (
                        <p style={{ fontSize: "12px", color: theme.mutedForeground, margin: 0, fontStyle: "italic" }}>
                          — Dynamic (pulls from matching table data)
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Bottom Info Legend bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              padding: "12px 20px",
              borderTop: `1px solid ${theme.border}`,
              backgroundColor: "rgba(241, 245, 249, 0.2)",
              fontSize: "11px",
              color: theme.mutedForeground,
            }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: theme.muted, border: `1px solid ${theme.border}`, display: "inline-block" }} /> Dynamic Column
            </span>
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: theme.amberSolid, display: "inline-block" }} /> Static Custom Value
            </span>
          </div>

          {/* Action Footer */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "14px 20px",
              borderTop: `1px solid ${theme.border}`,
            }}
          >
            <p style={{ fontSize: "12px", color: theme.mutedForeground, margin: 0 }}>
              {mappings.filter((r) => r.isStatic === 'Y').length} static · {mappings.filter((r) => r.isStatic !== 'Y').length} dynamic
            </p>
            <button
              onClick={handleSubmit}
              disabled={!isReady}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 16px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "600",
                border: "none",
                cursor: isReady ? "pointer" : "not-allowed",
                transition: "all 0.2s",
                backgroundColor: isReady ? theme.primary : theme.muted,
                color: isReady ? theme.primaryForeground : theme.mutedForeground,
                boxShadow: isReady ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
              }}
            >
              <Save size={14} /> Save Mapping
            </button>
          </div>
        </div>
      
      )}
      {/* )} */}

      {/* Empty State */}
      {!tempName && (
        <div
          style={{
            backgroundColor: theme.card,
            borderRadius: "12px",
            border: `1px solid ${theme.border}`,
            padding: "40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            textAlign: "center",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
        >
          <div style={{ width: "48px", height: "48px", borderRadius: "16px", backgroundColor: theme.muted, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Columns size={22} style={{ color: theme.mutedForeground }} />
          </div>
          <p style={{ fontSize: "14px", fontWeight: "600", color: theme.foreground, margin: 0 }}>Select configurations to begin</p>
          <p style={{ fontSize: "12px", color: theme.mutedForeground, maxWidth: "320px", margin: 0, lineHeight: "1.5" }}>
            Choose an approved template and source table above to configure data structural properties.
          </p>
        </div>
      )}
    </div>
  );
};

export default ColumnMapping;